import SecureStorage from "secure-web-storage";
import * as CryptoJS from 'crypto-js'
import { environment } from 'src/environments/environment';

var XCODE = environment.x_code;
var secureStorage = new SecureStorage(sessionStorage, {
  hash: function hash(key) {
    key = CryptoJS.SHA256(key, XCODE);
    return key.toString();
  },
  encrypt: function encrypt(data) {
    data = CryptoJS.AES.encrypt(data, XCODE);
    data = data.toString();
    return data;
  },
  decrypt: function decrypt(data) {
    data = CryptoJS.AES.decrypt(data, XCODE);
    data = data.toString(CryptoJS.enc.Utf8);
    return data;
  }
});

try {
  if (getStorage('storeData') == null) {
    secureStorage.clear()
    setStorage('storeData', 'ข้อมุลที่เก็บจะมีอายุจนถึงเวลา ของวันถัดไป 02:50:00')
  }
} catch (error) {
  secureStorage.clear()
  console.debug(error)
}


export function encryptData(data) {
  data = CryptoJS.AES.encrypt(data, XCODE);
  data = data.toString();
  return data;
}
export function decryptData(data) {
  data = CryptoJS.AES.decrypt(data, XCODE);
  data = data.toString(CryptoJS.enc.Utf8);
  return data;
}

export function getAge(year, month, day) {
  month = +month - 1;
  var today = new Date();
  var birthDate = new Date(year, month, day);
  var age = today.getFullYear() - birthDate.getFullYear();
  //console.log('getage',year,'/', month,'/', day,":",age,">",birthDate.getMonth(),today.getMonth())
  if (birthDate.getMonth() < today.getMonth()) {
    age++;
  } else if (birthDate.getMonth() == today.getMonth() && birthDate.getDate() < today.getDate()) {
    age++;
  }
  if (isNaN(age)) {
    age = 0;
  }

  return age;
}

export function getTodayNextYear(n: number = 1, type: string = 'dmy') {
  let today = new Date();
  let year = today.getFullYear();
  let month = today.getMonth();
  let day = today.getDate();
  let date = new Date(year + n, month, day);

  let result: any = '';
  if (type = 'dmy') {
    result = [date.getDate(), date.getMonth() + 1, date.getFullYear()];
  }
  return result
}

export function getDateCustom(option:{"d"?:number,"m"?:number,"y"?:number,"type"?:string}) {
  let today = new Date();
  let year = today.getFullYear();
  let month = today.getMonth();
  let day = today.getDate();
  let date = new Date(year + (option.y || 0), month+ (option.m || 0), day+(option.d || 0));

  let result: any = '';
  if ((option?.type || 'dmy') == 'dmy') {
    result = [date.getDate(), date.getMonth() + 1, date.getFullYear()];
  }
  return result
}

export function getDayInMonth(month, year) {
  let maxDay = new Date(year, month, 0).getDate();
  let days = [];
  for (let i = 1; i <= maxDay; i++) {
    days.push(i);
  }
  return days;
}

export function setDateData(strDate?: string) {
  var today = new Date()
  var params: any = (strDate || '').split('-')
  var date = today
  if (params.length == 3) {
    if (params[2].lenght == 4) {
      date = new Date(params[2], params[1] - 1, params[0])
    } else {
      date = new Date(params[0], params[1] - 1, params[2])
    }
  }

  var year = date.getFullYear()
  var month = date.getMonth() + 1
  var day = date.getDate()

  var days = []
  var months = []
  var years = []

  for (let i = year - 5; i <= year + 5; i++) {
    years.push(i)
  }
  for (let i = month - 5; i <= month + 5; i++) {
    if (i <= 0) {
      months.push(12 + i)
    } else {
      months.push(i)
    }
  }

  var m0 = getDayInMonth(month - 1, year)
  var m = getDayInMonth(month, year)
  for (let i = day - 5; i <= day + 5; i++) {
    if (i == day - 5 && i <= 0) {
      for (let j = m0.length + i; j <= m0.length; j++) {
        days.push(j)
      }
    } else if (i > 0 && i <= m.length) {
      days.push(i)
    } else if (i >= m.length) {
      days.push(i - m.length)
    }
  }
  return { days: days, months: months, years: years }
}

export function getYearsRange(min, max) {
  let years = [];
  min = isNaN(+min) ? 1 : +min;
  max = isNaN(+max) ? 80 : +max;
  let yearStart = new Date().getFullYear() - (min - 1);
  let yearEnd = new Date().getFullYear() - (max - 1);
  for (let i = yearStart; i >= yearEnd; i--) {
    years.push(i);
  }
  return years;
}

export function daysInMonth(month: number, year: number): number {
  return (month === 4 || month === 6 || month === 9 || month === 11) ? 30 : (month === 2) ? isLeapYear(year) ? 29 : 28 : 31;
}

export function isLeapYear(year: number): boolean {
  return (year % 4 === 0 && year % 100 !== 0) || (year % 400 === 0);
}

/** @hidden */
export function isBoolean(val: any): val is boolean { return typeof val === 'boolean'; }
/** @hidden */
export function isString(val: any): val is string { return typeof val === 'string'; }
/** @hidden */
export function isNumber(val: any): val is number { return typeof val === 'number'; }
/** @hidden */
export function isFunction(val: any): val is Function { return typeof val === 'function'; }
/** @hidden */
export function isDefined(val: any): boolean { return typeof val !== 'undefined'; }
/** @hidden */
export function isUndefined(val: any): val is undefined { return typeof val === 'undefined'; }
/** @hidden */
export function isPresent(val: any): val is any { return val !== undefined && val !== null; }
/** @hidden */
export function isBlank(val: any): val is null { return val === undefined || val === null; }
/** @hidden */
export function isObject(val: any): val is Object { return typeof val === 'object'; }
/** @hidden */
export function isArray(val: any): val is any[] { return Array.isArray(val); }



/** @hidden */
export function isPrimitive(val: any) {
  return isString(val) || isBoolean(val) || (isNumber(val) && !isNaN(val));
}


/** @hidden */
export function isTrueProperty(val: any): boolean {
  if (typeof val === 'string') {
    val = val.toLowerCase().trim();
    return (val === 'true' || val === 'on' || val === '');
  }
  return !!val;
}

function getWebCrypto(): Crypto {
  const cryptoApi = globalThis.crypto;
  if (!cryptoApi?.getRandomValues) {
    throw new Error('Web Crypto API is not available');
  }
  return cryptoApi;
}

export function secureRandomHex(byteLength: number): string {
  const bytes = new Uint8Array(byteLength);
  getWebCrypto().getRandomValues(bytes);
  return Array.from(bytes, (byte) => byte.toString(16).padStart(2, '0')).join('');
}

export function secureRandomInt(maxExclusive: number): number {
  if (!Number.isInteger(maxExclusive) || maxExclusive <= 0) {
    throw new Error('secureRandomInt: maxExclusive must be a positive integer');
  }
  const randomBuffer = new Uint32Array(1);
  const randomLimit = Math.floor(0x1_0000_0000 / maxExclusive) * maxExclusive;
  let randomValue = 0;
  do {
    getWebCrypto().getRandomValues(randomBuffer);
    randomValue = randomBuffer[0];
  } while (randomValue >= randomLimit);
  return randomValue % maxExclusive;
}

export function createUUID(): string {
  const cryptoApi = globalThis.crypto;
  if (cryptoApi?.randomUUID) {
    return cryptoApi.randomUUID();
  }
  const bytes = new Uint8Array(16);
  getWebCrypto().getRandomValues(bytes);
  bytes[6] = (bytes[6] & 0x0f) | 0x40;
  bytes[8] = (bytes[8] & 0x3f) | 0x80;
  const hex = Array.from(bytes, (byte) => byte.toString(16).padStart(2, '0')).join('');
  return `${hex.slice(0, 8)}-${hex.slice(8, 12)}-${hex.slice(12, 16)}-${hex.slice(16, 20)}-${hex.slice(20)}`;
}

export function removeStorage(name) {
  try {
    secureStorage.removeItem(name);
    secureStorage.removeItem(name + '_expiresIn');
  } catch (e) {
    console.log('removeStorage: Error removing key [' + name + '] from localStorage: ' + JSON.stringify(e));
    return false;
  }
  return true;
}

export function getStorage(key): any {
  var now = new Date().getTime();  //epoch time, lets deal only with integer
  // set expiration for storage
  try {
    var expiresIn = +(secureStorage.getItem(key + '_expiresIn'));
    if (expiresIn === undefined || expiresIn === null) { expiresIn = 0; }
    //console.log(expiresIn , now)
    if (expiresIn < now) {// Expired
      removeStorage(key);
      return null;
    } else {
      try {
        var value = secureStorage.getItem(key);
        return value
      } catch (error) {
        return null
      }

    }
  }
  catch (e) {
    return null
  }

}

export function setStorage(key: string, value: any, expires?: number) {

  if (expires === undefined || expires === null) {
    //expires = (24 * 60 * 60);  // default: seconds for 1 day
    expires = 60 * 60 * 24;  // default: seconds for  1 day
  } else {
    expires = Math.abs(expires); //make sure it's positive
  }

  //var now = Date.now();  //millisecs since epoch time, lets deal only with integer
  let today = new Date();
  let year = today.getFullYear();
  let month = today.getMonth();
  let day = today.getDate();
  let startDate = year + '-' + pad(month + 1) + '-' + pad(day);
  let now = new Date(startDate + ' 02:50:00').getTime();

  var schedule = now + expires * 1000;
  try {
    secureStorage.setItem(key, value);
    secureStorage.setItem(key + '_expiresIn', '' + schedule);
  } catch (e) {
    console.log('setStorage: Error setting key [' + key + '] in localStorage: ' + JSON.stringify(e));
    return false;
  }
  return true;
}

export function pad(n, len = 2) {
  let l = Math.floor(len)
  let sn = '' + n
  let snl = sn.length
  if (snl >= l) return sn
  return '0'.repeat(l - snl) + sn
}

export function formatMoney(amount: any, decimalCount: any = 2, decimal: any = ".", thousands: any = ",", defaultValue: any = '', defaultZero: any = '') {
  let amountValue = parseFloat(('' + amount).replace(/,/g, ''))
  let [n, d] = ('' + amountValue).split(".")
  amount = +n
  if (+d > 0) {
    amount = amount + 1
  }
  try {
    decimalCount = Math.abs(decimalCount);
    decimalCount = isNaN(decimalCount) ? 2 : decimalCount;

    const negativeSign = amount < 0 ? "-" : "";

    let i: any = parseInt(amount = Math.abs(Number(amount) || 0).toFixed(decimalCount)).toString();
    let j: any = (i.length > 3) ? i.length % 3 : 0;
    let result: any = negativeSign + (j ? i.substr(0, j) + thousands : '') + i.substr(j).replace(/(\d{3})(?=\d)/g, "$1" + thousands) + (decimalCount ? decimal + Math.abs(amount - i).toFixed(decimalCount).slice(2) : "");
    result = result.replace('.00', '')
    if (thousands == '' && decimal == '.') {
      result = +result
    }

    if (defaultValue != '' && result == 0) {
      return defaultValue
    }
    if (defaultZero != '' && result == 0) {
      return defaultZero
    }

    return result
  } catch (e) {
    console.log(e)
    return null
  }
}


export function formatMoneyDiscount(amount: any, decimalCount: any = 2, decimal: any = ".", thousands: any = ",", defaultValue: any = '', defaultZero: any = '') {
  let amountValue = parseFloat(('' + amount).replace(/,/g, ''))
  let [n, d] = ('' + amountValue).split(".")
  amount = +n

  try {
    decimalCount = Math.abs(decimalCount);
    decimalCount = isNaN(decimalCount) ? 2 : decimalCount;

    const negativeSign = amount < 0 ? "-" : "";

    let i: any = parseInt(amount = Math.abs(Number(amount) || 0).toFixed(decimalCount)).toString();
    let j: any = (i.length > 3) ? i.length % 3 : 0;
    let result: any = negativeSign + (j ? i.substr(0, j) + thousands : '') + i.substr(j).replace(/(\d{3})(?=\d)/g, "$1" + thousands) + (decimalCount ? decimal + Math.abs(amount - i).toFixed(decimalCount).slice(2) : "");
    result = result.replace('.00', '')
    if (thousands == '' && decimal == '.') {
      result = +result
    }

    if (defaultValue != '' && result == 0) {
      return defaultValue
    }
    if (defaultZero != '' && result == 0) {
      return defaultZero
    }

    return result
  } catch (e) {
    console.log(e)
    return null
  }
}

export function secConverter(number, unit) {
  let d, h, m, s

  if (isNaN(number)) {
    throw new TypeError('Value sent to seconds-converter must be a number.')
  }

  if (unit === 'sec' || unit === 'seconds') {
    s = number
  } else if (unit === 'ms' || unit === 'milliseconds' || !unit) {
    s = Math.floor(number / 1000)
  } else {
    throw new TypeError(`Unit must be 'sec' or 'ms'`)
  }

  m = Math.floor(s / 60)
  s = s % 60
  h = Math.floor(m / 60)
  m = m % 60
  d = Math.floor(h / 24)
  h = h % 24

  return { days: d, hours: h, minutes: m, seconds: s }
}

export function moblieOtp(mobile) {
  let value = mobile
  let result = ''
  for (let i = value.length - 1; i > value.length - 4; i--) {
    let str = value.charAt(i)
    result = str + result
  }
  result = 'XXX-XXXX-' + result
  return result;
}

export function b64EncodeUnicode(str) {
  return btoa(encodeURIComponent(str).replace(/%([0-9A-F]{2})/g, (_match, p1) =>
    String.fromCharCode(parseInt(p1, 16))
  ))
}

export function getLiffNumber(comcode) {
  const channelRef = environment.sourceOfData;
  return channelRef[comcode];
}

export function formatQrBarCode(amount, decimalCount = 2, decimal = "", thousands = "") {
  let amountValue:any = parseFloat(('' + amount).replace(/,/g, ''))
  amountValue = amountValue.toFixed(2);
  return amountValue.replace('.', '');
}

export async function sleep(delayInms = 1000) {
  return new Promise(resolve => {
    setTimeout(() => {
      resolve(2);
    }, delayInms);
  });
}